import { Component, Inject } from '@angular/core';
import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import {
  menuDividerStylesSAG,
  menuDividerStylesSHS,
} from './menu-divider.styles';

@Component({
  selector: 'sag-ui-menu-item-divider',
  template: ` <div [class]="styles"></div> `,
})
export class MenuDividerComponent {
  constructor(@Inject(THEME_TOKEN) private readonly theme: Theme) {}

  protected get styles() {
    return componentStylesByTheme(
      this.theme,
      menuDividerStylesSAG,
      menuDividerStylesSHS,
    )();
  }
}
